// Web implementation of settings storage using localStorage – no expo-file-system import.

export async function saveSetting(key: string, value: any) {
  const settings = JSON.parse(localStorage.getItem('settings') || '{}');
  settings[key] = value;
  localStorage.setItem('settings', JSON.stringify(settings));
}

export async function loadSetting(key: string, defaultValue: any = null): Promise<any> {
  const settings = JSON.parse(localStorage.getItem('settings') || '{}');
  return settings[key] !== undefined ? settings[key] : defaultValue;
}

export async function loadAllSettings(): Promise<{ [key: string]: any }> {
  return JSON.parse(localStorage.getItem('settings') || '{}');
}
